import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider, useAuth } from "@/context/AuthContext";

import PortalLogin from "@/pages/PortalLogin";
import FieldDashboard from "@/pages/FieldDashboard";
import ShopDashboard from "@/pages/ShopDashboard";
import AdminDashboard from "@/pages/AdminDashboard";

function Protected({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-stone-500">Loading...</div>;
  if (!user) return <Navigate to="/" replace />;
  const home = user.role === "admin" ? "/admin" : user.role === "shop_worker" ? "/shop" : "/field";
  if (role && user.role !== role) return <Navigate to={home} replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster richColors position="top-right" />
          <Routes>
            <Route path="/" element={<PortalLogin />} />
            <Route path="/portal" element={<Navigate to="/" replace />} />
            <Route path="/field" element={<Protected role="field_worker"><FieldDashboard /></Protected>} />
            <Route path="/shop" element={<Protected role="shop_worker"><ShopDashboard /></Protected>} />
            <Route path="/admin" element={<Protected role="admin"><AdminDashboard /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
